import Vue from 'vue';
import countries from '@/assets/rawData/countries.json';
import { mapGetters } from 'vuex';
import examples from 'libphonenumber-js/examples.mobile.json';
import { isValidPhoneNumber, parsePhoneNumber, getExampleNumber } from 'libphonenumber-js';
import Inputmask from 'inputmask';
import { VInput } from 'vuetify/lib';
const countriesArr = [];
var InputTypes;
(function (InputTypes) {
    InputTypes[InputTypes["Dial"] = 0] = "Dial";
    InputTypes[InputTypes["Iso"] = 1] = "Iso";
    InputTypes[InputTypes["Phone"] = 2] = "Phone";
})(InputTypes || (InputTypes = {}));
export default Vue.extend({
    name: 'phoneinput',
    extends: VInput,
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        currentPhone: {
            type: String,
            required: false
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        countryISO: '',
        dial: '',
        errorsBucket: [],
        errorBucket: [],
        preferredCountries: [],
        selectedCountry: '',
        ISOList: [],
        valid: false,
        countriesListIsOpened: false,
        inputboxFocused: false,
        hoverForced: false,
        touched: false
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserCountryISO'])), { computedValue: {
            get() { return this.value; },
            set(v) {
                const vm = this;
                vm.$emit('input', v);
                const isCurrentPhoneEqualValue = `${vm.dial}${v}`.replace(/\s/g, '') === vm.currentPhone;
                if (this.currentPhone && isCurrentPhoneEqualValue)
                    this.errorsBucket.push(this.$t('global.youCantAddCurrentNumber'));
                else
                    this.errorsBucket.splice(vm.errorsBucket.findIndex((item) => item === this.$t('global.youCantAddCurrentNumber')), 1);
                const commonValid = isValidPhoneNumber(vm.dial + v, vm.countryISO.toUpperCase());
                if (commonValid)
                    this.errorsBucket.splice(vm.errorsBucket.findIndex((item) => item === this.$t('global.incorrectNumber')), 1);
                else
                    vm.errorsBucket.push(this.$t('global.incorrectNumber'));
            }
        }, reducedPreffered() {
            return this.preferredCountries.map((item) => {
                return {
                    iso2: item.iso2.toUpperCase(),
                    dialCode: '+' + item.dialCode,
                    name: item.name
                };
            }).sort((a, b) => {
                if (a.priority < b.priority)
                    return -1;
                if (a.priority > b.priority)
                    return 1;
                return 0;
            });
        } }),
    watch: {
        errorBucket(newArray) {
            const vm = this;
            vm.errorsBucket.forEach((item) => {
                const errorsIndex = newArray.findIndex((el) => el === item);
                if (errorsIndex < 0)
                    vm.errorBucket.push(item);
            });
        },
        dial(v) {
            const vm = this;
            if (!v.length) {
                vm.dial = '+';
            }
            else {
                if (!v.includes('+')) {
                    vm.dial = '+' + v;
                }
            }
            vm.$emit('dialChange', vm.dial);
            const valid = isValidPhoneNumber(v + vm.computedValue, vm.countryISO.toUpperCase());
        },
        countriesListIsOpened(v) {
            const vm = this;
            if (v) {
                vm.$refs.countryISO.focus();
            }
            else {
                if (document.activeElement === vm.$refs.countryISO) {
                    setTimeout(() => { vm.countriesListIsOpened = true; }, 100);
                }
            }
        },
        getUserCountryISO(v) {
            const vm = this;
            if (v) {
                vm.countryISO = this.getUserCountryISO;
                vm.doSet(InputTypes.Iso);
            }
            else {
                vm.countryISO = 'ru';
                vm.doSet(InputTypes.Iso);
            }
        },
        inputboxFocused(v, oldV) {
            if (v) {
                this.touched = true;
            }
        }
    },
    methods: {
        handleCountryISOBlur() {
            const vm = this;
            vm.countriesListIsOpened = false;
            if (vm.dial.length > 1 && vm.preferredCountries.length) {
                vm.$refs.phone.focus();
            }
        },
        handlePhoneUp(event) {
            const vm = this;
            if (event.keyCode === 8 && vm.computedValue.length === 0)
                vm.$refs.dial.focus();
        },
        handleCountryISOKeydown(event) {
            const vm = this;
            const k = event.key;
            const re = /^[A-Za-z]+$/;
            if (!re.test(k)) {
                event.preventDefault();
            }
        },
        handleCountryISOKeyup(event) {
            const vm = this;
            const k = event.key;
            const re = /^[A-Za-z]+$/;
            if (re.test(k)) {
                vm.doSet(InputTypes.Iso);
            }
        },
        handleSelectOfList(name) {
            const vm = this;
            vm.countryISO = name.iso2;
            vm.doSet(InputTypes.Iso);
        },
        handleDialKeydown(event) {
            const vm = this;
            if (vm.dial.length === 1 && event.keyCode === 8) {
                event.preventDefault();
                vm.$refs.countryISO.focus();
            }
        },
        handleDialKeyup(event) {
            const vm = this;
            function findDial(dial) {
                let trueDial = dial;
                while (trueDial.length) {
                    const finded = countriesArr.filter((item) => item.dialCode === trueDial);
                    if (finded.length) {
                        const sorted = finded.sort((a, b) => {
                            if (a.priority < b.priority)
                                return -1;
                            if (a.priority > b.priority)
                                return 1;
                            return 0;
                        });
                        return sorted[0].dialCode;
                    }
                    else
                        trueDial = trueDial.slice(0, -1);
                }
                return null;
            }
            if (vm.dial.length === 4) {
                const finded = findDial(vm.dial.slice(1));
                if (finded) {
                    const dialEnd = vm.dial.replace('+' + finded, '');
                    vm.dial = '+' + finded;
                    vm.doSet(InputTypes.Dial);
                    vm.computedValue = dialEnd;
                    vm.$refs.phone.focus();
                }
            }
            else {
                vm.doSet(InputTypes.Dial);
            }
        },
        doSet(inputType) {
            const vm = this;
            const { dial, countryISO, preferredCountries: preferred } = vm;
            vm.errorBucket = [];
            vm.errorsBucket = [];
            if (inputType !== InputTypes.Phone) {
                vm.computedValue = '';
            }
            function findCountries(type, v) {
                let arg = v;
                let currType = type;
                if (type === 'iso2') {
                    currType = 'dialCode';
                    const founded = countriesArr.find((item) => item.iso2.toLowerCase().match(v.toLowerCase()));
                    if (founded) {
                        arg = founded.dialCode;
                    }
                    else
                        arg = '';
                }
                const founded = countriesArr.filter((item) => item[currType] === arg);
                if (founded.length) {
                    checkFounded(founded);
                }
                else
                    checkFounded(null);
            }
            function doResetRecent() {
                if (inputType === InputTypes.Iso) {
                    vm.dial = '';
                }
                else {
                    vm.countryISO = '';
                }
                vm.computedValue = '';
            }
            function checkFounded(founded) {
                if (Array.isArray(founded)) {
                    if (inputType === InputTypes.Dial) {
                        const splitted = dial.split('+')[1];
                        if (splitted.length >= 1 && splitted.length <= 3) {
                            const toSet = founded.filter((item) => item.dialCode.length === dial.split('+')[1].length);
                            setAll(toSet);
                        }
                    }
                    else if (inputType === InputTypes.Iso) {
                        if (countryISO.length > 1 && countryISO.length < 3) {
                            setAll(founded);
                        }
                    }
                }
                else {
                    if (inputType !== InputTypes.Phone) {
                        if (vm.dial.length - 1) {
                            if (inputType === InputTypes.Dial) {
                                vm.errorBucket.push('registration.errors.dialNotFound');
                                vm.errorsBucket.push('registration.errors.dialNotFound');
                            }
                            else {
                                vm.errorBucket.push('registration.errors.countryNotFound');
                                vm.errorsBucket.push('registration.errors.countryNotFound');
                            }
                            doResetRecent();
                        }
                        else {
                            vm.errorBucket.push('registration.errors.dialEmpty');
                            vm.errorsBucket.push('registration.errors.dialEmpty');
                            doResetRecent();
                        }
                    }
                }
            }
            function setMask() {
                const phoneExampleRaw = getExampleNumber(vm.countryISO.toUpperCase(), examples);
                const phoneExapmle = vm.dial + (phoneExampleRaw === null || phoneExampleRaw === void 0 ? void 0 : phoneExampleRaw.nationalNumber.replace(/[0-9]/g, '9')) || '';
                const phoneNumber = parsePhoneNumber(phoneExapmle).formatInternational().replace(vm.dial + ' ', '');
                const { phone: phoneRef } = vm.$refs;
                Inputmask(phoneNumber, { placeholder: '_', clearMaskOnLostFocus: false, inputmode: 'numeric' }).mask(phoneRef);
            }
            function setAll(founded) {
                const sorted = founded.sort((a, b) => {
                    if (a.priority < b.priority)
                        return -1;
                    if (a.priority > b.priority)
                        return 1;
                    return 0;
                });
                if (inputType === InputTypes.Dial) {
                    vm.countryISO = sorted[0].iso2.toUpperCase();
                    setMask();
                }
                else if (inputType === InputTypes.Iso) {
                    vm.dial = '+' + sorted[0].dialCode;
                    setMask();
                }
                vm.preferredCountries = sorted;
            }
            if (inputType === InputTypes.Dial) {
                findCountries('dialCode', dial.split('+')[1]);
            }
            else if (inputType === InputTypes.Iso) {
                findCountries('iso2', countryISO);
            }
        }
    },
    mounted() {
        if (this.getUserCountryISO) {
            this.countryISO = this.getUserCountryISO.toUpperCase();
            this.doSet(InputTypes.Iso);
        }
        this.valid = false;
        if (this.autofocus)
            this.$refs.phone.focus();
    },
    created() {
        for (var i = 0; i < countries.length; i++) {
            const c = countries[i];
            countriesArr[i] = {
                name: c[0],
                iso2: c[1],
                dialCode: c[2],
                priority: c[3] || 0,
                areaCodes: c[4] || null
            };
        }
        this.ISOList = countriesArr.map((item) => {
            return {
                iso2: item.iso2.toUpperCase(),
                dialCode: '+' + item.dialCode,
                name: item.name
            };
        });
    }
});
